export const dharamshalas = [{
  "_id": {
    "$oid": "640987ac899d8a50d29de630"
  },
  "name": "bharat sevashram sangha",
  "address": "WARD N0. - 04, UKHIMATH, RUDRAPRAYAG",
  "email": "ashrambharatseva@gmail.com",
  "phone": "Mobile: 9410127123Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de631"
  },
  "name": "birla mangal niketan",
  "address": "GANGOTRI, UTTARKASHI, UTTARKASHI",
  "email": "SHAILESH.SEMWAL11@GMAIL.COM",
  "phone": "Mobile: 9411345817Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de633"
  },
  "name": "baba ji kriya yog ashram",
  "address": "BADRINATH, BADRINATH, CHAMOLI",
  "email": "rohit.naithani@gmail.com",
  "phone": "Mobile: 9412381505Ph: 0135-9410110138"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de634"
  },
  "name": "chandra yoga meditation ashram",
  "address": "VILL-GANGA BHOGPUR, PATTI- UDAYPUR PALLA, YAMKESHWAR, PAURI",
  "email": "chandrayoga591@gmail.com",
  "phone": "Mobile: 8057049232Ph: 0135-2433777"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de635"
  },
  "name": "devloka house dharamshala",
  "address": "Devloka House Dharamshala Tibbetan Colony, Clement Town, Dehradun",
  "email": "norjinhospitality@gmail.com",
  "phone": "Mobile: 6398440010Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de636"
  },
  "name": "dhanwantri bhawan dharamshala-unit darbar shri guru ram rai ji maharaj",
  "address": "Laxman Jhula Road Rishikesh, Rishikesh, DEHRADUN",
  "email": "bpd9410@gmail.com",
  "phone": "Mobile: 7830700471Ph: 05942-247029"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de638"
  },
  "name": "gujrat bhawan yatri niwas",
  "address": "NETALA, UTTARKASHI, UTTARKASHI",
  "email": "gujratbhawanuki@gmail.com",
  "phone": "Mobile: 9410108238Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de639"
  },
  "name": "haidakhandi samaj",
  "address": "Haidakhan Vishva Maha Dham, Vill/PO - Haidakhan (v, NAINITAL, NAINITAL",
  "email": "HAIDAKHANDISAMAJORG@GMAIL.COM",
  "phone": "Mobile: 9690556957Ph: 05946-281081",
  "website": "HAIDAKHANDISAMAJ.IN"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de63a"
  },
  "name": "iskcon new vrindaban east",
  "address": "MADHUBAN ASHRAM MUNI KI RETI RISHIKESH, RISHIKESH, RISHIKESH",
  "email": "info@madhubanashram.com",
  "phone": "Mobile: 9897899970Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de63b"
  },
  "name": "kk birla dharmshala charitable trust",
  "address": "RUDRAPRYAG, RUDRAPRYAG, RUDRAPRYAG",
  "email": "rakeshpkkothari@gmail.com",
  "phone": "Mobile: 9758407522Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de63c"
  },
  "name": "mahadev devi nepali kshetra trust rishikesh",
  "address": "562, Lakshman Jhula Road, Rishikesh, Dehradun",
  "email": "nepalikshetra1910@gmail.com",
  "phone": "Mobile: 9758164325Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de63d"
  },
  "name": "manav utthan sewa samiti",
  "address": "SHIVLALPUR CHUNGI,KASHIPUR ROAD, RAMNAGAR, NAINITAL",
  "email": "ukmanavdharam@gmail.com",
  "phone": "Mobile: 8552894437Ph: 05942-247029"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de640"
  },
  "name": "mathrushree divine ashram",
  "address": "MUNI KI RETI DAYANAND NAGAR, RISHIKESH, TEHRI GARHWAL",
  "email": "amitadv69@gmail.com",
  "phone": "Mobile: 9639017777Ph: 0135-2433777"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de642"
  },
  "name": "manav uthan seva samiti ashram",
  "address": "VILL MATENA, DEENAPANI, ALMORA",
  "email": "office@manavdharam.org",
  "phone": "Mobile: 7451863369Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de643"
  },
  "name": "modi yoga retreat-a unit of smart vishwas",
  "address": "238 VEERBHADRA ROAD , RISHIKESH, DEHRADUN",
  "email": "modiyogar663@gmail.com",
  "phone": "Mobile: 9675536614Ph: 0135-2433777"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de644"
  },
  "name": "omkarananda dipeshwar mandir",
  "address": "Near Lakshman Jhula, Lakshmanjhula, Tehri Garhwal",
  "email": "omkara@oah.in",
  "phone": "Mobile: 9643524093Ph: 0135-2431307"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de645"
  },
  "name": "om anand dham",
  "address": "swargashram laxmanjhula, laxman jhula, laxman jhula",
  "email": "omanandswami22@gmail.com",
  "phone": "Mobile: 9410110138Ph: 0135-9410110138"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de648"
  },
  "name": "omkarananda shivalaya",
  "address": "Bhajangarh Road, MUNI KI RETI, TEHRI GARHWAL",
  "email": "cfo@oah.in",
  "phone": "Mobile: 8527227367Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de649"
  },
  "name": "onkarehwar dharamshala",
  "address": "TAPOVAN SARAI TEHRI GARHWAL, Rishikesh, TEHRI",
  "email": "kmtrust1917@gmail.com",
  "phone": "Mobile: 9719684186Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64a"
  },
  "name": "lakshmi narain mandir",
  "address": "GANDHI CHOWK, MUSSOORIE, MUSSOORIE",
  "email": "ashish@hotelvishnupalace.com",
  "phone": "Mobile: 9412932789Ph: 0135-9412932789"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64b"
  },
  "name": "patanjali international yoga foundation",
  "address": "TAPOVAN PO- SHIVANAND NAGAR, TAPOVAN, TEHRI GARHWAL",
  "email": "APT383@GMAIL.COM",
  "phone": "Mobile: 9760990205Ph: 0135-9412932789"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64c"
  },
  "name": "prashanti retreats",
  "address": "Kairwaan Karanpur, Rajpur, Dehradun",
  "email": "prashantiretreats@gmail.com",
  "phone": "Mobile: 9759650064Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64d"
  },
  "name": "patanjali international yoga foundation",
  "address": "TAPOVAN SARAI, RISHIKESH, TEHRI GARHWAL",
  "email": "APT838@GMAIL.COM",
  "phone": "Mobile: 9760990205Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64e"
  },
  "name": "phool chati yoga ashram",
  "address": "PO. LAXMAN JHULA ,RISHIKESH , NEELKANTH TEMPLE ROA, RISHIKESH, PAURI GARHWAL",
  "email": "PHOOLCHATTIASHRAM@GMAIL.COM",
  "phone": "Mobile: 9810889419Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de64f"
  },
  "name": "punjab sindh kshetra",
  "address": "punjab sindh kshetra nikat kali mandir uttarkashi, uttarkashi, uttarkashi",
  "email": "punjabsindhkshetrauki1909@gmail.com",
  "phone": "Mobile: 9411519295Ph: 01374-222621"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de650"
  },
  "name": "ramakrishna sarda mission",
  "address": "VILLAGE - PANGOT, NAINITAL, NAINITAL",
  "email": "RKSMPANGOT@GMAIL.COM",
  "phone": "Mobile: 9536604067Ph: 0135-2430227"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de651"
  },
  "name": "rishikesh yogashram trust",
  "address": "Village Pundrasu , Pauri Garwal , Pauri garwal",
  "email": "Rishikeshyogashramtrust@gmail.com",
  "phone": "Mobile: 9628861000Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de652"
  },
  "name": "satya sadhna sansthan",
  "address": "TAPOVAN, TAPOVAN, TEHRI GARHWAL",
  "email": "satyasadhna001@gmail.com",
  "phone": "Mobile: 8755129920Ph: 0135-9412932789"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de654"
  },
  "name": "sant sewa ashram",
  "address": "laxman jhula near taxi stand, rishikesh, PAURI GARHWAL",
  "email": "mehantgovind@gmail.com",
  "phone": "Mobile: 8979204993Ph: 05942-247029"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de655"
  },
  "name": "sattal christian ashram",
  "address": "Sattal, Bhimtal, Nainital",
  "email": "estate.sattal@gmail.com",
  "phone": "Mobile: 9927622044Ph: 05942-247029"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de656"
  },
  "name": "shree heera lalparvati devi dharamshala",
  "address": "T-12, NEW TEHRI, TEHRI GARHWAL",
  "email": "HELAL1234@REDIFFMAIL.COM",
  "phone": "Mobile: 7982218592Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de658"
  },
  "name": "shri maa katyani mandir gyan kartar asshram",
  "address": "C-79, SOUTH DELHI, DELHI",
  "email": "GKSALUJA@YAHOO.COM",
  "phone": "Mobile: 8920899269Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de659"
  },
  "name": "shri phool chand vaish aggarwal trust dharmshala",
  "address": "402- Haridwar Road, Rishikesh, Dehradun, Dehradun, Dehradun",
  "email": "sumitthapliyal031@gmail.com",
  "phone": "Mobile: 9811081420Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65a"
  },
  "name": "shri ram lila sampatti committee trust",
  "address": "Birla Road, Haridwar, Haridwar",
  "email": "virenderchaddha@gmail.com",
  "phone": "Mobile: 9837057505Ph: 01334-227150"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65b"
  },
  "name": "the  international samarpan yoga awareness foundation",
  "address": "Tapovan , Rishikesh , Tehrigarhwal",
  "email": "swamisamarpanashram@gmail.com",
  "phone": "Mobile: 9897166340Ph: 05942-247029"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65c"
  },
  "name": "vishv manav satsang",
  "address": "LUXMAN JHULA ROAD, TAPOVAN, TEHRI GARHWAL",
  "email": "vishvmanav100@gmail.com",
  "phone": "Mobile: 8755523314Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65d"
  },
  "name": "sri digamber jain mahavir bhawan dharamshala samiti",
  "address": "JAIN DHARAMSHALA, LANDOUR BAZAR NEAR CLOCK TOWER,MUSSOORIE, DEHRADUN",
  "email": "srpjain@gmail.com",
  "phone": "Mobile: 9837056124Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65e"
  },
  "name": "yog amritam trust",
  "address": "YOG AMRITAM TRUST VILL- TAPOVAN, TAPOVAN, TAPOVAN",
  "email": "yogamritam100@gmail.com",
  "phone": "Mobile: 9410342577Ph: 431297-9897899970"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de65f"
  },
  "name": "yoga niketan ashram",
  "address": "NEAR KEDAR MANDIR, UTTARKASHI, UTTARKASHI",
  "email": "YOGANIKETANUKI@GMAIL.COM",
  "phone": "Mobile: 9410901238Ph: 01374-9719684186"
},{
  "_id": {
    "$oid": "640987ac899d8a50d29de660"
  },
  "name": "yoga niketan trust",
  "address": "N/A, Rishikesh, Tehri Garhwal",
  "email": "info@yoganiketanashram.org",
  "phone": "Mobile: 6397514497Ph: 0135-2430227",
  "website": "www.yoganiketanashram.org"
}]